import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { ContainerComponent } from '../../container/container.component';
import { RouterModule } from '@angular/router';
import { appPaths } from '../../../../app.paths';

@Component({
  selector: 'nav[top]',
  imports: [CommonModule, ContainerComponent, RouterModule],
  templateUrl: './top.component.html',
  styleUrl: './top.component.scss',
})
export class TopComponent implements AfterViewInit {

  @Input() isSpanish!: boolean;

  link = appPaths;

  ngAfterViewInit(): void {
  }

}
